import { render, staticRenderFns } from "./VacancyCandidatesKanbanActions.vue?vue&type=template&id=11f7cd5d&scoped=true&"
import script from "./VacancyCandidatesKanbanActions.vue?vue&type=script&lang=js&"
export * from "./VacancyCandidatesKanbanActions.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCandidatesKanbanActions.vue?vue&type=style&index=0&id=11f7cd5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7cd5d",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCandidatesKanbanActions.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCandidatesKanbanActions.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VList,VListItem,VMenu,VRow})
